/* The run-status pill, extracted verbatim from traces/atoms.jsx. The showcase
   renders the very same component the traces screen does — that is the point of
   the page — so it has to sit below both. traces/atoms.jsx re-exports it. */

import React from "react";

const STATUS = {
  success: { label: "Completed", pill: "bg-[var(--success-bg)] text-[var(--success)] ring-[var(--success-ring)]" },
  attention: { label: "Needs attention", pill: "bg-[var(--warn-bg)] text-[var(--warn-text)] ring-[var(--warn-ring)]" },
  error: { label: "Failed", pill: "bg-[var(--danger-bg)] text-[var(--danger)] ring-[var(--danger-ring)]" },
  running: { label: "Running", pill: "bg-[var(--info-bg)] text-[var(--info-text)] ring-[var(--info-ring)]" },
};

export function StatusPill({ status }: { status?: string }) {
  const s = STATUS[status as keyof typeof STATUS] || STATUS.success;
  return (
    <span className={`shrink-0 whitespace-nowrap inline-flex items-center gap-1.5 text-[11.5px] font-medium pl-2 pr-2.5 py-[2px] rounded-full ${s.pill}`}>
      <span className={`w-[5px] h-[5px] rounded-full bg-current ${status === "running" ? "animate-pulse" : ""}`} />
      {s.label}
    </span>
  );
}
